import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";

/** Where the editor goes back to when it closes, carried in the navigation's state. */
export interface EditorOrigin {
  from?: string;
}

/**
 * Opening the rule editor, from wherever it is opened.
 *
 * The editor has an address — `/automatizaciones/nueva`, `/automatizaciones/12` — so a
 * reload keeps it open and "back" closes it. It remembers where it was opened from, so
 * closing it from the summary returns to the summary.
 */
export function useRuleEditor() {
  const navigate = useNavigate();
  const location = useLocation();

  const state: EditorOrigin = useMemo(() => ({ from: location.pathname + location.search }), [location]);

  const create = useCallback(
    (postId?: string) =>
      navigate(
        postId ? `/automatizaciones/nueva?publicacion=${encodeURIComponent(postId)}` : "/automatizaciones/nueva",
        {
          state,
        },
      ),
    [navigate, state],
  );

  const edit = useCallback((ruleId: number) => navigate(`/automatizaciones/${ruleId}`, { state }), [navigate, state]);

  return { create, edit };
}
